import React, { Fragment, useCallback, useState } from 'react';

import { Button, IconButton } from '@mui/material';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

import { useNotification } from '../../../context/NotificationContext';

import { createErrorMessage, isBlank } from '../../../utils/index';
import AddBonusTransactionModal from '../../adminToolsTabs/payoutManagement/PaymentsToolGrids/components/AddBonusTransactionModal';
import { AddErrorTransactionModal } from '../../adminToolsTabs/payoutManagement/PaymentsToolGrids/components/AddErrorTransactionModal';
import { EditErrorTransactionModal } from '../../adminToolsTabs/payoutManagement/PaymentsToolGrids/components/EditErrorTransactionModal';
import EditBonusTransactionModal from '../../adminToolsTabs/payoutManagement/PaymentsToolGrids/components/EditBonusTransactionModal';
import { useGetErrorTrackingPagedQuery } from '../../../services/errorTrackingApi';


import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useDecryptPlatformPasswordMutation } from '../../../services/platformsApi';

const ModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 350,
  padding: '1em',
  bgcolor: 'background.paper',
  borderRadius: '1em',
  boxShadow: 24,
}

export default function JobPurchaseForm({ purchase = {}, transactionTypes = [], relatedTransactions = [] }) {

  const { showNotification } = useNotification();

  let [modalIsOpen, setModalIsOpen]= useState(false);
  let [openBonusModal, setOpenBonusModal] = useState(false);
  let [openPenaltyModal, setOpenPenaltyModal] = useState(false);
  let [snackBarProp, setSnackBarProp] = useState({
    status: null,
    text: "",
    open: false
  });

  const [decryptPlatformPassword, { isLoading: loadingPlaformPassword, isError: errorPlatformPassword, error: errorPlatformPasswordMessage }] = useDecryptPlatformPasswordMutation();
  let placeHolder= "************"
  const [decryptedPassword, setDecryptedPassword] = useState(placeHolder);
  
  function initPasswordDecryption() {
    if(decryptedPassword != placeHolder){
      setDecryptedPassword(placeHolder);
      return;
    }
    decryptPlatformPassword(purchase.platformCredentialID).unwrap()
      .then((res) => {
        setDecryptedPassword(res.password);
      })
      .catch((err) => {
        console.log(err);
        showNotification(createErrorMessage(err), 'error');
      });
  }
  const {data: errorTracking, isLoading: errorTrackingIsLoading, isError: errorTrackingIsError, error: errorTrackingError, isFetching: errorTrackingIsFetching} = useGetErrorTrackingPagedQuery({relatedTransactionID: purchase.transactionID, isDeleted: false}, {skip: !purchase || !purchase.transactionID});

  const transactionTypeIsPenalty = useCallback((transactionTypeID) => {
    return (transactionTypes || []).find(transactionType => transactionType.id === transactionTypeID)?.name === "Penalty";
  }, [transactionTypes]);

  const transactionTypeIsBonus = useCallback((transactionTypeID) => {
    return (transactionTypes || []).find(transactionType => transactionType.id === transactionTypeID)?.name === "Bonus";
  }, [transactionTypes]);

  return (

    <Fragment>

      <div >
        {/* TITLE AND ID */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 0 1em 0' }}>
          <p style={{ color: "var(--orange)", fontWeight: '600' }} >Purchase Details</p>
          <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }} >
            <p style={{ margin: '0 0.25em 0 0', fontSize: 'var(--p2)', fontWeight:'600' }} >Transaction ID:</p>
            <p style={{ margin: '0 0.25em 0 0', fontSize: 'var(--p2)' }} >{purchase.transactionID || "-"}</p>
            <IconButton size='small' >
              <ContentCopyOutlinedIcon color='primary' fontSize='small' />
            </IconButton>
          </div>

        </div>

        <div>
          {/* BUYING EMAIL - BOX OFFICE PASSWORD - CREDIT CARD  */}
          <div className="bottom-inputs" style={{ marginBottom: "1em" }}>
            <div className="input-column" style={{ margin: "0 2em 1em 0" }} >
              <label style={{ marginRight: '0.5em' }}>Buying Email Used</label>
              <input
                disabled label="Email Account Used" name="orderNumber" style={{ width: "250px" }}
                value={purchase.buyingEmailAddress}
              />
            </div>

            <div className="input-column" style={{ margin: "0 2em 1em 0" }} >
              <label style={{ marginRight: '1em' }}>Box Office Password Used</label>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  disabled
                  label="Exchange Update Password"
                  name="exchangeUpdatePass"
                  value={decryptedPassword}
                  style={{ marginRight: '0.5em', width: '160px' }} // Añadido para un pequeño espacio entre el input y el botón
                />
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => initPasswordDecryption()}
                  disabled={loadingPlaformPassword}
                  edge="end"
                >
                  {
                    decryptedPassword === placeHolder ? <VisibilityOutlinedIcon color={loadingPlaformPassword? "grey" : "primary"} /> 
                    : <VisibilityOffOutlinedIcon color={loadingPlaformPassword? "grey" : "primary"} />}
                </IconButton>
              </div>
            </div>

            <div className="input-column" style={{ margin: "0 2em 1em 0" }}>
              <label style={{ marginRight: '0.5em' }}>Credit Card Used</label>
              <input
                disabled label="Credit Card Used" name="orderNumber" style={{ width: "250px" }}
                value={purchase?.creditCardName}
              />
            </div>

          </div>

          <div className="input-list" style={{ justifyContent: "flex-start" }}>

            <div className="input-column">
              <label>Quantity</label>
              <input
                disabled label="Quantity Purchased" name="quantityPurchashed"
                value={purchase.quantity}
              />
            </div>

            <div className="input-column">
              <label>Section</label>
              <input
                disabled label="Section Purchased" name="sectionPurchashed"
                value={purchase.section}
              />
            </div>

            <div className="input-column">
              <label>Row</label>
              <input
                disabled label="Row Purchased" name="rowPurchashed"
                value={purchase.row}
              />
            </div>

            <div className="input-column">
              <label>Seats</label>
              <input
                disabled label="Seats Purchased" name="seatsPurchashed"
                value={purchase.seats}
              />
            </div>

            <div className="input-column">
              <label>Delivery Method</label>
              <input
                id="delivery-method"
                disabled label="Code Used" name="Delivery Method"
                value={purchase.deliveryMethodName}
              />
            </div>

            <div className="input-column">
              <label>Total Spend </label>
              <input
                disabled label="Total Spend u$s" name="totalSpend"
                value={purchase.purchaseTotal}
              />
            </div>

            < div className="input-column">
              <label>Order Number</label>
              <input
                disabled label="Order Number" name="orderNumber"
                value={purchase.orderNumber}
              />
            </div>

            <div className="input-column">
              <label>Code Used</label>
              <input
                disabled label="Code Used" name="codeUsed"
                value={purchase.codeUsed}
              />
            </div>

          </div>

        </div>

      </div>
      <AddBonusTransactionModal purchase={purchase} transactionTypes={transactionTypes}  setSnackBarProp={setSnackBarProp} isOpen={openBonusModal} setIsOpen={setOpenBonusModal}/>
        <AddErrorTransactionModal modalIsOpen={openPenaltyModal} setModalIsOpen={setOpenPenaltyModal} selectedTransaction={{transactionID: purchase.transactionID}}/>

        <EditErrorTransactionModal modalIsOpen={modalIsOpen == 'EditError' } setModalIsOpen={setModalIsOpen} selectedTransaction={relatedTransactions[0]}/>
        <EditBonusTransactionModal isOpen={modalIsOpen == 'EditBonus' } setIsOpen={setModalIsOpen} selectedTransaction={relatedTransactions[0]}/>

        <div >
          {
            transactionTypeIsPenalty(relatedTransactions[0]?.transactionTypeID) &&
            <>
              <p style={{color: "red", marginBottom: "1em"}}>Error: {errorTracking?.items[0]?.errorReasonName + " - " + errorTracking?.items[0]?.notesForAdmin } </p>
              <Button variant='outlined' color='primary' onClick={()=> setModalIsOpen('EditError')} sx={{ margin: '0 1em 0 0' }}>Edit Error</Button>
            </>
          }

          {
            transactionTypeIsBonus(relatedTransactions[0]?.transactionTypeID) &&
              <>
              <p style={{color: "green", marginBottom: "1em"}}>Bonus: {isBlank(relatedTransactions[0].notesForAdmin) ? "No Internal Notes" : relatedTransactions[0].notesForAdmin}</p>
              <Button variant='outlined' color='primary' onClick={()=> setModalIsOpen('EditBonus')} sx={{ margin: '0 1em 0 0' }}>Edit Bonus</Button> 
              </>
          }

          {
            !transactionTypeIsPenalty(relatedTransactions[0]?.transactionTypeID) && !transactionTypeIsBonus(relatedTransactions[0]?.transactionTypeID) &&
            <>
              <Button
                variant='outlined'
                color='success'
                onClick={()=> setOpenBonusModal(true)}
                sx={{ margin: '0 1em 0 0' }}
              >
                Create Bonus
              </Button>

              <Button
                variant='outlined'
                color='error'
                onClick={()=> setOpenPenaltyModal(true)}
                sx={{ margin: '0 1em 0 0' }}
                
              >
              Create error
              </Button>
            </>
          }

        </div>


      <div style={{ display: 'flex', justifyContent: 'flex-end' }} >

        

        <div >
          <Button
            variant='contained'
            color='secondary'
            sx={{ margin: '0 1em 0 0' }}
          >
            Cancel Changes
          </Button>

          <Button
            variant='contained'
          >
            Save Changes
          </Button>
        </div>

      </div>
    </Fragment >

  )
}